import { render, staticRenderFns } from "./OxygenElementPropertiesPanel.vue?vue&type=template&id=e0cf6dde&"
import script from "./OxygenElementPropertiesPanel.vue?vue&type=script&lang=ts&"
export * from "./OxygenElementPropertiesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenElementPropertiesPanel.vue?vue&type=style&index=0&id=e0cf6dde&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports